import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { type ReviewsViewContext } from "@src/appV2/redesign/ShiftDiscovery/useWorkplaceModalsDataContext";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { type CommentReactionSource, type Reaction } from "../types";
import { CommentReactionButtons } from "./CommentReactionButtons";
import { LockedReviewOverlay } from "./LockedReviewOverlay";
import { WorkplaceReviewCommentRepliesAndLikesWrapper } from "./RepliesAndLikesWrapper";

export interface CompactCardLockedContentProps {
  commentText: string;
  maxLines?: number;
  showEngagementActions: boolean;
  workerReaction?: Reaction;
  totalLikes: number;
  totalDislikes: number;
  workplaceId: string;
  commentId: string;
  reactionSource: CommentReactionSource;
  viewContext: ReviewsViewContext;
  isLocked: boolean;
  onLikeChanged: (comment: WorkplaceCommentType) => void;
  onUnlockPress?: () => void;
}

export function CompactCardLockedContent(props: CompactCardLockedContentProps) {
  return (
    <LockedReviewOverlay
      anchorOverlayToParent
      isLocked={props.isLocked}
      onUnlockPress={props.onUnlockPress}
    >
      {props.commentText && (
        <Text
          variant="body2"
          sx={{
            ...(isDefined(props.maxLines) && {
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: props.maxLines,
              WebkitBoxOrient: "vertical",
            }),
          }}
        >
          {props.commentText}
        </Text>
      )}
      {props.showEngagementActions && (
        <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{ marginTop: 4 }}>
          <WorkplaceReviewCommentRepliesAndLikesWrapper>
            <CommentReactionButtons
              workerReaction={props.workerReaction}
              totalLikes={props.totalLikes}
              totalDislikes={props.totalDislikes}
              workplaceId={props.workplaceId}
              commentId={props.commentId}
              source={props.reactionSource}
              viewContext={props.viewContext}
              onReactionChanged={props.onLikeChanged}
            />
          </WorkplaceReviewCommentRepliesAndLikesWrapper>
        </Stack>
      )}
    </LockedReviewOverlay>
  );
}
